import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

/**
 * Hook to synchronize sorting state with URL parameters
 *
 * @param {Object} options - Configuration options
 * @param {string} options.sortBy - Current sortBy value
 * @param {string} options.sortDirection - Current sortDirection value
 * @param {Function} options.handleSortBy - Function to update sortBy
 * @param {Function} options.handleSortDirection - Function to update sortDirection
 * @returns {void}
 */
export const useSyncUrlSort = ({ sortBy, sortDirection, handleSortBy, handleSortDirection }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isInitialSync = useRef(true);

  useEffect(() => {
    if (!location.pathname || !searchParams) {
      return;
    }

    const urlSortBy = searchParams.get('sortBy');
    const urlSortDirection = searchParams.get('sortDirection');

    // Only sync from URL to state on initial render or when URL path changes
    if (isInitialSync.current || location.pathname) {
      if (urlSortBy && urlSortBy !== sortBy) {
        handleSortBy(urlSortBy);
      }

      if (urlSortDirection && urlSortDirection !== sortDirection) {
        handleSortDirection(urlSortDirection);
      }

      isInitialSync.current = false;
    }
  }, [location.pathname, searchParams]);
};
